import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './lib/auth';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import ConciergeList from './pages/ConciergeList';
import CreateConcierge from './pages/CreateConcierge';
import ConciergeDetail from './pages/ConciergeDetail';
import GroupList from './pages/groups/GroupList';
import CreateGroup from './pages/groups/CreateGroup';
import GroupDetail from './pages/groups/GroupDetail';
import { muiThemePartial } from './theme-tokens';

const theme = createTheme(muiThemePartial);
const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000 } },
});

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/login" element={<Login />} />
              <Route element={<ProtectedRoute />}>
                <Route path="/concierges" element={<ConciergeList />} />
                <Route path="/concierges/new" element={<CreateConcierge />} />
                <Route path="/concierges/:id" element={<ConciergeDetail />} />
                <Route path="/groups" element={<GroupList />} />
                <Route path="/groups/new" element={<CreateGroup />} />
                <Route path="/groups/:id" element={<GroupDetail />} />
                <Route path="*" element={<Navigate to="/concierges" replace />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
